
const baseUrl: string = "https://ithub-pos-api.ithub-webhost.net";
const name: string = "IT HUB POS [QAs]";

export const environment = {
  production: true,
  appName: `${name}`,
  apiUrl: `${baseUrl}/api`,
  ticketsUrl: `${baseUrl}/Tickets`,
  cashClosingUrl: `${baseUrl}/CashClosing`,
  customerStatementsUrl: `${baseUrl}/CustomerStatements`,
  CSVTemplate: `${baseUrl}/csv-files/ITHUB-POS-PLANTILLA-PRODUCTOS.xlsx`,
};
